export const FETCH_PARTIES_DATA = "FETCH_PARTIES_DATA";
export const DELETE_PARTY = "DELETE_PARTY";
export const ACTIVATE_DEACTIVATE_PARTY = "ACTIVATE_DEACTIVATE_PARTY";
